<template>
  <Form
    @submit="onSave"
    :validation-schema="{
      name: 'required',
    }"
  >
    <div>
      <h4 class="mb-6 text-secondary">
        {{ action === "create" ? "Crear" : "Editar" }} subcontratista
      </h4>
    </div>
    <div class="pb-4">
      <label class="text-dark font-semibold text-sm">Nombre</label>
      <Field v-model="name" name="name" v-slot="{ field }">
        <input
          v-bind="field"
          type="text"
          class="
            relative
            py-2
            px-2
            w-full
            bg-white
            rounded
            border
            outline-none
            text-gray-700
            placeholder-gray-400
            focus:outline-none focus:shadow-outline
            mt-2
          "
          placeholder="Ingrese nombre del subcontratista"
        />
      </Field>
      <div>
        <ErrorMessage name="name" v-slot="{ message }">
          <p class="text-red-500 pt-1 text-sm text-left">{{ message }}</p>
        </ErrorMessage>
      </div>
    </div>
    <Alert
      v-if="responseMessage"
      :type="responseType"
      :text="responseMessage"
    ></Alert>
    <div class="text-left pb-10">
      <button
        class="rounded bg-primary py-2 px-8 text-white font-medium flex"
        type="submit"
        :disabled="loadingSave"
      >
        <LoadingButtonIcon v-if="loadingSave" />
        Guardar
      </button>
    </div>
  </Form>
</template>

<script setup>
import { defineProps, defineEmits, ref } from "vue";
import { useStore } from "vuex";
import { useField } from "vee-validate";

const props = defineProps({
  action: {
    type: String,
    default: "create",
  },
  subcontractorSelected: {
    type: Object,
    default: () => {},
  },
});
const emits = defineEmits(["onComplete"]);
const store = useStore();
const { value: name } = useField("name");

const loadingSave = ref(false);
const responseType = ref(null);
const responseMessage = ref(null);

const init = () => {
  if (props.action === "update") name.value = props.subcontractorSelected.name;
};

init();

const onSave = async (values, { resetForm }) => {
  try {
    loadingSave.value = true;
    responseType.value = null;
    responseMessage.value = null;

    if (props.action === "create")
      await store.dispatch("createSubcontractor", {
        subcontractor: {
          name: values.name,
        },
      });
    else
      await store.dispatch("updateSubcontractor", {
        subcontractor: {
          key: props.subcontractorSelected.key,
          name: values.name,
        },
      });

    resetForm();

    emits("onComplete");
  } catch (error) {
    responseType.value = "error";
    responseMessage.value =
      error.message ||
      "Hubo un problema al guardar la información del subcontratista";
  } finally {
    loadingSave.value = false;
  }
};
</script>
